export default "<app-header></app-header>\r\n\r\n<app-footer></app-footer>"